import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React, { useContext, useRef, useState } from "react";
import { DataDescriptor } from "../../context/DataDescriptor";
import styles from "../../css/TextFields.module.css";
import { updateDescriptionSegment } from "../../utils/descriptions/description";
import { handleRegionUpdate } from "../../utils/regions/regions";
import { BarActions } from "../toolbar/BarActions";

export const TextFields = () => {
  const {
    setComments,
    setDescription,
    description,
    comments,
    charactersCount,
    recommendCharacterMax,
    regions,
    currentRegion,
    startTime,
    endTime,
    setWordsCount,
    setDuration,
    setCharactersCount,
    setRecommendCharacterMin,
    setRecommendCharacterMax,
  } = useContext(DataDescriptor);

  const descriptionField=useRef();
  const saveRequestId = useRef(0);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");

  const checkDescription = (e) => {
    setDescription(e.target.value);
  };


  const getSavedDescriptionMessage = (savedDescription) => {
    const descriptionText = savedDescription?.trim() || "Empty description";
    return `Description saved: ${descriptionText}`;
  };

  const handleTextAreaDescription = async (e) => {
    const newDescription = e.target.value;
    const currentSaveRequest = saveRequestId.current + 1;

    saveRequestId.current = currentSaveRequest;
    setDescription(newDescription);

    let result;

    try {
      result = await updateDescriptionSegment(
        currentRegion,
        newDescription,
        startTime,
        endTime,
        setWordsCount,
        setDuration,
        setCharactersCount,
        setRecommendCharacterMin,
        setRecommendCharacterMax
      );
    } catch (error) {
      result = { status: false };
    }

    if (saveRequestId.current !== currentSaveRequest) {
      return;
    }

    if (result?.status) {
      setToastMessage(getSavedDescriptionMessage(newDescription));
      setToastSeverity("success");
    } else {
      setToastMessage("Error saving description");
      setToastSeverity("error");
    }
    setOpenToast(true);
  };

  const handleTextAreaComments = (e) => {
    setComments(e.target.value);
    handleRegionUpdate(
      currentRegion,
      e.target.value,
      "comments",
      regions,
      currentRegion,
      startTime,
      endTime,
      setWordsCount,
      setDuration,
      description,
      setCharactersCount,
      setRecommendCharacterMin,
      setRecommendCharacterMax
    );
  };

  return (
    <>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={toastSeverity}
          sx={{ maxWidth: "80vw", wordBreak: "break-word" }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>
      <div className={styles.container__TextLabel}>
        <div className={styles.label__TextField}>
          <div className={styles.title__TextField}>
            <ArticleOutlinedIcon /> <h3>Description</h3>
          </div>
          <BarActions />
        </div>
        <div className={styles.container__descriptioTextFiel}>
          <textarea
            ref={descriptionField}
            placeholder="Enter a description"
            value={currentRegion.data?.description?.initial}
            disabled={currentRegion.data?.review?.approved ? true : false}
            onLoadStart={(e) => {
              checkDescription(e);
            }}
            onChange={(e) => {
              handleTextAreaDescription(e);
            }}
            className={styles.textArea_description}
          />
          <div
            className={styles.container__count}
            style={{
              color:
                charactersCount > Math.round(recommendCharacterMax)
                  ? "red"
                  : "green",
            }}
          >
            <span className={styles.span__characterCount}>
              {Math.round(recommendCharacterMax)-charactersCount}
            </span>
          </div>
        </div>
        <div className={styles.container__textCount}>
          {charactersCount > Math.round(recommendCharacterMax) && (
            <h4 style={{ color: "var(--orange)" }}>
              {" "}
              WARNING: You have exceeded the limit{" "}
              {Math.round(recommendCharacterMax)}
            </h4>
          )}
        </div>
      </div>
      <div className={styles.container__TextLabel}>
        <label className={styles.label__TextField}>
          {" "}
          <div className={styles.title__TextField}>
            <ChatBubbleOutlineOutlinedIcon /> <h3>Annotation</h3>
          </div>
        </label>

        <textarea
          placeholder="Enter an annotation"
          value={comments}
          style={{ marginTop: '5px' }}
          disabled={currentRegion.data?.review?.approved ? true : false}
          onChange={(e) => handleTextAreaComments(e)}
          className={styles.textArea_description}
        />
      </div>
    </>
  );
};
